<div class="content-section">
    <h2 class="section-title">¿Qué es el Informe de Pensiones Personalizado?</h2>
    <p class="section-description">
        Es un documento PDF que incluye un resumen de tus ahorros, su rentabilidad e instrumentos de inversión junto con
        asesoría y sugerencias que te permitirán tomar decisiones sobre tu futuro financiero. Revisa más detalles en el
        siguiente video:
    </p>
    <div class="video-container">
        <app-youtube-player [videoId]="videoId"></app-youtube-player>
    </div>
</div>